<template>
  <div
    class="CardProductSpecItemCmp d-flex align-items-center justify-content-between"
  >
    <span class="font-medium"><slot name="label" /></span>
    <span><slot name="value" /></span>
  </div>
</template>

<script>
export default {
  name: 'CardProductSpecItemCmp',
};
</script>

<style scoped lang="scss">
.CardProductSpecItemCmp {
  padding-bottom: 2px;
  border-bottom: 1px solid currentColor;
}
</style>
